import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ReadQueryString extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: null,
            serials: null
        };

        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            this.state.token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImNpcm8uZm9ybWlzYW5vQGFpcmdsb3NzLmNvbSIsImlhdCI6MTU3MTU3NTQzNX0.IXXpGz5DN_C7JulFmGfibJYw0Je8U2OQ6o-pK0T4PNg';
            this.state.serials = [
                'AP064ZAN',
                'AP001ZAN',
                'AP046ZAN',
                // 'AP064ZAN',
                // 'AP060ZAN',
            ];
            this.state.title = 'Title';
            this.state.provider = 'PROVIDER';
        } else {
            const res = this.parseQs();
            this.state.token = res.token;
            this.state.serials = res.serials;
            this.state.title = res.title;
            this.state.provider = res.provider;
        }

        this.updateQs = this.updateQs.bind(this);
    }

    componentDidMount() {
        this.updateBodyClass();
        window.addEventListener("hashchange", this.updateQs, false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.serials !== this.state.serials) {
            this.updateBodyClass();
        }
    }

    updateBodyClass() {
        if (this.state.serials.length < 4) {
            document.body.classList.add('two-devices');
        } else {
            document.body.classList.remove('two-devices');
        }
    }

    updateQs() {
        const res = this.parseQs();
        this.setState(res);
    }

    parseQs () {
        // location.hash // "#token=asdad&serials=13452,23123"
        const strings = window.location.hash.slice(1).split('&');
        const values = {};
        for (const str of strings) {
            const [key, value] = str.split('=');
            values[key] = value;
        }
        values['serials'] = values['serials'] && values['serials'].split(',');
        const token = values['token'];
        const serials = values['serials'];
        const title = decodeURIComponent(values['title'] || '');
        const provider = decodeURIComponent(values['provider'] || '');

        return {token, serials, title, provider}
    }

    render() {
        if (!this.state.token) {
            return '#token=????????????????'
        }

        if (!this.state.serials) {
            return '#token=?????&serials=AA111ZAB,AA222ZAB,AA333ZAB,AA444ZAB,AA555ZAB'
        }

        return this.props.children({
            token: this.state.token,
            serials: this.state.serials,
            title: this.state.title,
            provider: this.state.provider
        })
    }
}

ReadQueryString.propTypes = {};

export default ReadQueryString;
